import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9fea75c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-survey" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center bg-white border px-6 py-4"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка опроса...", -1))
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = { class: "flex items-center justify-between mt-6" }
const _hoisted_7 = { class: "flex items-center justify-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_10 = { class: "mt-6 bg-white border px-6 py-4" }
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_variant_form = _resolveComponent("variant-form")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_surveys_form = _resolveComponent("surveys-form")!
  const _component_survey_variant = _resolveComponent("survey-variant")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_variant_form, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createVariant,
          onUpdate: _ctx.updateVariant,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 1,
          loading: _ctx.state.is_loading,
          text: "При получении опроса произошла ошибка",
          onRefresh: _ctx.loadSurvey
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_page_title, { title: "Редактирование опроса" }),
                  _createVNode(_component_the_button, {
                    class: "second text small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createTextVNode(" Назад ")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_surveys_form, {
                  class: "mt-6",
                  "is-update": "",
                  "initial-value": _ctx.state.survey,
                  "survey-id": _ctx.survey_id
                }, null, 8, ["initial-value", "survey-id"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_page_title, {
                    title: `Варианты (${_ctx.state.survey.variants.length})`
                  }, null, 8, ["title"]),
                  _createElementVNode("div", _hoisted_7, [
                    (!_ctx.isHaveAdditionalVariant)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary small text mr-3",
                          loading: _ctx.actions_state.is_actions_loading,
                          onClick: _ctx.addAdditionalVariant
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createTextVNode(" Добавить вариант \"Другое\" ")
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_button, {
                      class: "primary small text",
                      onClick: _ctx.startCreate
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createTextVNode(" Добавить вариант ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.state.survey.variants.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Нет вариантов "))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.survey.variants, (variant, i) => {
                        return (_openBlock(), _createBlock(_component_survey_variant, {
                          key: `survey-variant-${i}`,
                          variant: variant,
                          count: _ctx.totalComputedAnswers,
                          class: _normalizeClass({ 'mt-3': i !== 0 }),
                          "is-update": "",
                          onDeleted: _ctx.onVariantDeleted,
                          onUpdate: ($event: any) => (_ctx.startUpdate(variant))
                        }, null, 8, ["variant", "count", "class", "onDeleted", "onUpdate"]))
                      }), 128))
                ])
              ], 64))
        ], 64))
  ]))
}